import { useTranslation } from "react-i18next";
import { formatNumberWithSpaces } from "utils/formatNumberWithSpaces";
import { customToFixed } from "utils/toFixedNumber";
import useCoreStore from "views/hooks/useCoreStore";

export default function useBestSellingProductsTableColumns() {
  const { t } = useTranslation();

  const currency = useCoreStore(state => state.currency);
  const currencyCode = currency?.code;
  const decimalPlaces = currency?.decimalPlaces;

  return [
    {
      title: t("Reference"),
      dataIndex: "reference",
      key: "reference",
    },
    {
      title: t("Name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Volume"),
      dataIndex: "volume",
      key: "volume",
      width: "120px",
      render: (_text: unknown, record: { volume?: number; totalValueDefaultCurrency?: number }) => {
        return <span>{`${Number(record?.volume).toFixed(decimalPlaces)}`}</span>;
      },
    },
    {
      title: t("Turnover before tax"),
      dataIndex: "totalValueDefaultCurrency",
      key: "totalValueDefaultCurrency",
      width: "200px",
      render: (_text: unknown, record: { volume?: number; totalValueDefaultCurrency?: number }) => {
        return (
          <span>{`${formatNumberWithSpaces(
            customToFixed(Number(record?.totalValueDefaultCurrency), decimalPlaces || 0),
          )} ${currencyCode}`}</span>
        );
      },
    },
  ];
}
